import React from 'react';
import moment from 'moment';
import DayPicker from 'react-day-picker';
import 'react-day-picker/lib/style.css';
import '../../../style/styles.scss'

function getWeekDays(weekStart) {
  const days = [weekStart];
  for (let i = 1; i <= 7; i += 1) {
    days.push(
      moment(weekStart)
        .add(i, 'days')
        .toDate()
    );
  }
  return days;
}

function getWeekRange(date) {
  return {
    from: moment(date)
      .startOf('week')
      .toDate(),
    to: moment(date)
      .endOf('week')
      .toDate(),
  };
}

export default class WeekSelector extends React.Component {

  state = {
    hoverRange: undefined,
    selectedDays: [],
    updateComponent: false,
  };

  buildWeekDate = () => {
    const oneWeek = "date1="
      + moment(this.state.selectedDays[0]).format("YYYY-MM-DD")
      + "T03:00:00Z&date2="
      + moment(this.state.selectedDays[6]).format("YYYY-MM-DD")
      + "T23:00:00Z";
    return oneWeek;
  };

  handleDayChange = date => {
    this.setState({
      selectedDays: getWeekDays(getWeekRange(date).from),
    });
  };

  handleDayEnter = date => {
    //console.log("RBM: " + moment(this.state.selectedDays[0]).format("YYYY-MM-DD HH:mm"));
    this.setState({
      hoverRange: getWeekRange(date),
    });
  };

  handleDayLeave = () => {
    let newWeek = this.buildWeekDate();
    this.props.weekChangeHandler(newWeek);
    console.log("RMB 7: " + newWeek);
    this.setState({
      hoverRange: undefined,
    });
  };

  handleWeekClick = (weekNumber, days, e) => {
    let newWeek = this.buildWeekDate();
    this.props.weekChangeHandler(newWeek);
    console.log("RBM 3: " + newWeek);
    this.setState({
      selectedDays: days,
      updateComponent: true,
    });
  };

  render() {
    const {hoverRange, selectedDays} = this.state;

    const daysAreSelected = selectedDays.length > 0;

    const modifiers = {
      hoverRange,
      selectedRange: daysAreSelected && {
        from: selectedDays[0],
        to: selectedDays[6],
      },
      hoverRangeStart: hoverRange && hoverRange.from,
      hoverRangeEnd: hoverRange && hoverRange.to,
      selectedRangeStart: daysAreSelected && selectedDays[0],
      selectedRangeEnd: daysAreSelected && selectedDays[6],
    };

    return (
      <div className="xyr-weekSelector">
        <div className="container_row">
          <div className="level1">
            <div className="left">
              <div className="SelectedWeekExample">
                <DayPicker
                  selectedDays={selectedDays}
                  showWeekNumbers
                  showOutsideDays
                  modifiers={modifiers}
                  onDayClick={this.handleDayChange}
                  onDayMouseEnter={this.handleDayEnter}
                  onDayMouseLeave={this.handleDayLeave}
                  onWeekClick={this.handleWeekClick}
                />
                {selectedDays.length === 7 && (
                  <div>
                    {moment(selectedDays[0]).format('LL')} –{' '}
                    {moment(selectedDays[6]).format('LL')}
                  </div>
                )}
              </div>
            </div>
          </div>
          <div className="level2"/>
        </div>
      </div>
    );
  }
}
